import createAuth from './auth'
import createSocketStatus from './socketStatus'
import createPlayer from './player'
import createStatus from './status'
import createSelection from './selection'
import createMc from './mc'
import createSuperAdmin from './superadmin'

export default (type, socket) => {
    console.tron.log('SOCKET: INIT LISTENERS')
    // Common listeners
    createAuth(socket)
    createSocketStatus(socket)

    if (type === 'superadmin') {
        // Only player listeners
        createSuperAdmin(socket)
    } else if (type === 'admin') {
        // Only Mc listeners
        createMc(socket)
    } else {
        // Only player listeners
        createPlayer(socket)
        createStatus(socket)
        createSelection(socket)
    }
}



// WEBPACK FOOTER //
// src/api/listeners/index.js